module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/cooking-book-638be483eb7f03026f6beae75cbc5290.svg";